/* eslint-disable import/no-anonymous-default-export */
import { CREATESTORE, FETCHSTORE, UPDATESTORE } from "../constants/actionTypes";

export default (store = {}, action) => {
  switch (action.type) {
    case CREATESTORE:
      localStorage.setItem("store", JSON.stringify({ ...action?.data }));
      return action.data;
    case UPDATESTORE:
      return store?._id === action?.payload._id ? action?.payload : store;
    case FETCHSTORE:
      return action.payload;
    default:
      return store;
  }
};
